import { init as loader } from './layout/loader';
import { bindAjaxButtons } from './layout/request';
import { init as symfonyRouting } from './layout/routing';
import { init as fastclick } from './layout/fastclick';
import { init as datepicker } from './layout/datepicker';
import { init as changeMenuTheme } from './layout/user-layout';
import { init as classToggle } from './layout/class-toggle';
import { init as orientationLock } from './layout/orientation-lock';
import { init as tabnav } from './layout/tabnav';
import { init as topnav } from './layout/topnav';
import { init as tabs } from './layout/tabs';
import { init as offcanvas } from './layout/offcanvas';
import { Select } from './layout/select';

import { init as alerts } from './layout/alerts';
import { init as sliderTemplates } from './layout/slider-templates';
import { init as sliderNowOnline } from './layout/slider-now-online';
import { init as sliderAsideSettings } from './layout/slider-aside-settings';
import { init as statsCircle } from './components/stats-circle';
import { init as datatables } from './components/datatables';
import { init as popup } from './layout/popup';
import { init as drafts } from './drafts/drafts';
import { init as clock } from './user-settings/clock';
import { init as quickResponse } from './quick_response/index';
import { init as quickResponseClient } from './quick_response/clientside';
import { init as card } from './layout/payform';
import { init as datatableForm } from './layout/datatableForm';
import { init as selectAjax } from './layout/selectAjax';
import { init as draftPopups } from './layout/draft-popups';

//temporary
import { init as pusher } from './layout/pusher';
import { setTranslations } from './layout/translations'
import { init as estiSettingsRates } from './estimation-settings/rates'
import { init as estiSettingsRows } from './estimation-settings/rows'

//Rewriting
// import { init as dataTablesClass} from './components/DatatablesClass';

loader();
bindAjaxButtons();
popup();
symfonyRouting();
fastclick();
datepicker();
changeMenuTheme();
classToggle();
orientationLock();
tabnav();
topnav();
tabs();
offcanvas();
alerts();
sliderTemplates();
sliderNowOnline();
sliderAsideSettings();
statsCircle();
datatables();
drafts();
clock();
quickResponse();
quickResponseClient();

card();
datatableForm();
selectAjax();
Select.init();
draftPopups();
//rewriting
// dataTablesClass();

//temporary
pusher();
setTranslations();
estiSettingsRates();
estiSettingsRows();


// WEBPACK FOOTER //
// ./src/_app/index.js